<template>
  <CommonContainer class="page-template-stockists" title="Stockists">
    <Stockists v-if="stockists.length" :stockists="stockists" />
  </CommonContainer>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { fetchStockists, Stockist as StockistType } from '_library'

import Stockists from '../stockists/Stockists.vue'
import CommonContainer from '../common/CommonContainer.vue'

const stockists = ref<StockistType[]>([])

onMounted(async () => {
  stockists.value = await fetchStockists()
})
</script>

<style lang="scss">
@import '~styles/base.scss';

.page-template-stockists {
  .heading {
    h1 {
      @include heading-l-serif;
      text-transform: none;
    }
  }

  .stockists-component {
    display: flex;
    width: columns(20);
    margin-left: columns(1);

    .badge {
      position: relative;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 13px;
      height: 11px;
      padding-top: 2px;
      margin-right: 2px;
      color: var(--color-lightgrey);
      font-size: 7px;
      line-height: 1;
      transform: translateY(-2px);

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 1px solid;
        border-radius: 100%;
      }
    }

    .legend {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      width: 200px;
      padding-right: 10px;

      .key {
        position: sticky;
        top: 160px;
        margin-bottom: 80px;
      }

      .key-heading {
        @include uppercase;
        margin-bottom: 35px;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-lightgrey);
      }

      .key-list {
        display: flex;
        flex-direction: column;

        .key-item + .key-item {
          margin-top: 4px;
        }
      }
    }

    .regions {
      flex: 1;
    }

    .region {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 70px;

      .region-name {
        @include uppercase;
        width: 100%;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-lightgrey);
      }
    }

    .subregion-row {
      position: relative;
      display: flex;
      // flex-wrap: wrap;
      width: 100%;
      overflow: hidden;
      border-bottom: 1px solid transparent;
      transition: padding 0.6s ease;

      &.active {
        border-color: var(--color-lightgrey);
      }
    }

    .subregion {
      // TODO:
      width: calc(100% / 6);
      // min-width: 150px;
      padding: 35px 0 0;

      .subregion-heading {
        $heading-opacity: 0.35;
        min-height: 40px;
        padding-right: 10px;
        cursor: pointer;
        transition: opacity 0.3s ease;

        &:focus,
        &:hover {
          opacity: $heading-opacity;
        }

        &.inactive {
          opacity: $heading-opacity;
        }

        &.active,
        &.inactive {
          &:focus,
          &:hover {
            opacity: 1;
          }
        }
      }

      .subregion-name,
      .subregion-count {
        display: inline;
      }

      .subregion-name {
        @include serif;
        @include type-l;
        line-height: 1.1;
      }

      .subregion-count {
        color: var(--color-lightgrey);
      }
    }

    .stockists {
      @include helper-link-underline;
      position: absolute;
      top: 80px;
      left: 0;
      width: 100%;
      border-top: 1px solid var(--color-lightgrey);
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.4s ease;

      &.active {
        opacity: 1;
        pointer-events: auto;
      }
    }

    .stockists-row {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      border-top: 1px solid var(--color-lightgrey);

      &:first-child {
        border-top: none;
      }
    }

    .stockist {
      // TODO:
      width: calc(100% / 6);
      padding-top: 15px;
      padding-bottom: 30px;
      margin-bottom: -1px;

      .stockist-name {
        display: inline;
      }

      .badges {
        display: inline-flex;
        gap: 4px;
        margin-left: 4px;
      }
    }
  }

  @include breakpoint('xl') {
    .stockists-component {
      .legend {
        width: 120px;
      }
    }
  }

  @include breakpoint('m') {
    .stockists-component {
      flex-direction: column;
      margin: 0 var(--inset);
      width: auto;

      .legend {
        width: 100%;

        .key-list {
          flex-direction: row;
        }

        .key-item + .key-item {
          margin: 0 0 0 10px;
        }
      }
    }
  }
}
</style>
